export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  tag: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
}

export const articles: Article[] = [
  {
    slug: 'newborn-feeding-guide',
    title: '新生儿喂养全攻略：从第一口奶到辅食添加，这些细节决定宝宝健康',
    excerpt: '新生儿的喂养是新手妈妈最关心的话题之一。从母乳喂养的正确姿势到配方奶的选择，再到辅食添加的黄金时机，本文为您梳理一份科学完整的喂养指南。',
    content: `<p>新生儿的到来给家庭带来了无限喜悦，同时也会让新手妈妈面临许多喂养上的困惑。正确的喂养方式不仅关系到宝宝的生长发育，更影响着宝宝一生的健康基础。以下是一份详尽的新生儿喂养指南，希望能帮助每位妈妈从容应对。</p>
<h3>一、母乳喂养：最佳的选择</h3>
<p>母乳是宝宝最理想的食物。世界卫生组织建议，婴儿出生后6个月内应进行纯母乳喂养。母乳中含有丰富的抗体和营养物质，能够帮助宝宝建立免疫系统，降低感染风险。</p>
<p><strong>正确哺乳姿势：</strong>让宝宝的头部和身体成一条直线，肚子紧贴妈妈的肚子。宝宝的嘴要含住大部分乳晕，而不仅仅是乳头。每次喂奶时间约15-20分钟，两侧乳房交替喂养。</p>
<p><strong>按需喂养原则：</strong>新生儿胃容量小，需要频繁喂养。一般每天8-12次，观察宝宝的饥饿信号——咂嘴、吮吸手指、转头寻找等，及时响应宝宝的需求。</p>
<h3>二、配方奶喂养：科学选择</h3>
<p>当母乳不足或无法母乳喂养时，选择一款合适的配方奶粉至关重要。选择时需关注以下几点：</p>
<p><strong>奶源地：</strong>优选新西兰、荷兰、澳洲等黄金奶源带的奶粉品牌，这些地区的自然环境优越，奶牛养殖标准严格。</p>
<p><strong>营养成分：</strong>关注DHA、ARA、益生元等关键营养素的含量，这些成分对宝宝的大脑发育和肠道健康至关重要。</p>
<p><strong>品牌信誉：</strong>选择有良好口碑和国际认证的品牌，避免购买来路不明的产品。</p>
<h3>三、辅食添加：抓住黄金期</h3>
<p>宝宝满4-6个月时，单纯的母乳或配方奶已不能满足其营养需求，需要逐步添加辅食。</p>
<p><strong>添加信号：</strong>宝宝能够稳定坐立、对食物表现出兴趣、挺舌反射消失时，就可以开始尝试添加辅食了。</p>
<p><strong>添加原则：</strong>从单一到多样、从稀到稠、从细到粗、从少量到多量。首选高铁米粉，然后逐步引入蔬菜泥、水果泥、肉泥等。</p>
<p>每位宝宝都是独特的个体，喂养过程中遇到任何问题，建议及时咨询专业儿科医生或营养师。蜜芽为妈妈们精选全球优质奶粉和辅食品牌，让您轻松选购放心产品。</p>`,
    category: '育儿知识',
    tag: 'feeding',
    author: '蜜芽育儿专家团',
    date: '2025-12-18',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20nursery%20scene%20with%20baby%20bottle%20and%20soft%20blankets%2C%20gentle%20natural%20light%20from%20window%2C%20peaceful%20atmosphere%2C%20cream%20and%20beige%20tones%2C%20motherhood%20aesthetic&width=800&height=500&seq=article-1&orientation=landscape',
  },
  {
    slug: 'diaper-selection-tips',
    title: '纸尿裤怎么选？5个维度教你挑出最适合宝宝的那一款',
    excerpt: '市面上的纸尿裤品牌琳琅满目，如何为宝宝挑选一款柔软、透气、吸水性好的纸尿裤？本文从材质、吸收、透气、防漏和舒适度五个维度为您逐一分析。',
    content: `<p>纸尿裤是宝宝成长过程中消耗量最大的日用品之一。一款好的纸尿裤能让宝宝保持干爽舒适，远离红屁屁的困扰。本文将从五个关键维度帮助妈妈们科学选购纸尿裤。</p>
<h3>一、材质亲肤性</h3>
<p>宝宝的皮肤厚度只有成人的三分之一，非常娇嫩。纸尿裤的面层材质直接接触宝宝皮肤，必须柔软亲肤。优质的纸尿裤通常采用热风无纺布面层，触感如棉花般柔软，减少对宝宝皮肤的摩擦。</p>
<p><strong>选购建议：</strong>可以用手背感受纸尿裤内层的柔软度，越柔软对宝宝皮肤越友好。日本品牌花王、大王等在材质工艺上一直处于行业领先地位。</p>
<h3>二、吸水性能</h3>
<p>吸水速度和吸水总量是衡量纸尿裤品质的核心指标。高分子吸水树脂（SAP）的含量和质量直接决定了纸尿裤的吸水性能。</p>
<p><strong>测试方法：</strong>可以做一个简单的吸水实验，将200ml温水倒入纸尿裤，观察吸收速度和表面干爽程度。优秀的纸尿裤能在30秒内完全吸收，且表面保持干爽。</p>
<h3>三、透气性</h3>
<p>宝宝的小屁屁长时间包裹在纸尿裤中，如果透气性差，湿热环境容易滋生细菌，导致尿布疹。优质的纸尿裤底层采用透气微孔膜，让湿热气体可以排出，同时防止尿液外漏。</p>
<h3>四、防漏设计</h3>
<p>立体防漏隔边和大腿根部弹力设计是防止侧漏的关键。选购时注意检查纸尿裤两侧的防漏隔边是否有弹性，能否紧密贴合宝宝大腿。</p>
<h3>五、尺码与舒适度</h3>
<p>纸尿裤的尺码应根据宝宝的体重选择，但不同品牌的尺码标准略有差异。过紧会勒出红印，过松则容易漏尿。魔术贴的可重复粘贴性和腰围弹性也是影响舒适度的重要因素。</p>
<p>蜜芽为您汇集了花王、帮宝适、大王等全球知名纸尿裤品牌，正品保障，让妈妈们买得放心、宝宝用得舒心。</p>`,
    category: '育儿知识',
    tag: 'health',
    author: '蜜芽育儿专家团',
    date: '2025-11-25',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Soft%20baby%20diapers%20arranged%20on%20light%20wooden%20surface%20with%20gentle%20sunlight%2C%20clean%20minimal%20aesthetic%2C%20warm%20cream%20tones&width=800&height=500&seq=article-2&orientation=landscape',
  },
  {
    slug: 'baby-toys-development',
    title: '0-3岁宝宝玩具挑选指南：不同月龄的益智玩具推荐',
    excerpt: '玩具不仅是宝宝的玩伴，更是促进感官发育、认知发展和动手能力的重要工具。本文按照宝宝不同月龄阶段，为您推荐最适合的益智玩具。',
    content: `<p>玩具在宝宝成长中扮演着不可或缺的角色。好的玩具能够激发宝宝的好奇心，促进感官、认知和运动能力的发展。以下按照不同年龄段，为妈妈们推荐适合的玩具类型。</p>
<h3>0-6个月：感官刺激期</h3>
<p>这个阶段的宝宝主要通过视觉、听觉和触觉来感知世界。推荐黑白卡、摇铃、床铃、软胶咬咬乐等能够刺激感官的玩具。</p>
<p><strong>黑白卡和彩色卡</strong>有助于宝宝视觉追踪能力的发展，<strong>摇铃和沙锤</strong>能够锻炼听觉感知和抓握能力。</p>
<h3>6-12个月：探索操作期</h3>
<p>宝宝开始学会坐和爬，手部精细动作也在快速发展。推荐堆叠杯、形状配对盒、敲击琴、软积木等能够促进手眼协调的玩具。</p>
<p><strong>费雪健身架</strong>是这个阶段非常经典的玩具，宝宝躺着时可以踢踏钢琴键，坐着时可以拍打悬挂的玩具，全面锻炼大运动能力。</p>
<h3>1-2岁：认知启蒙期</h3>
<p>宝宝开始学走路，语言能力也在快速发展。推荐推拉玩具、简单拼图、图画书、角色扮演玩具等。</p>
<p><strong>乐高得宝系列</strong>的大颗粒积木非常适合这个年龄段，宝宝可以通过搭建来锻炼空间想象力和精细动作。</p>
<h3>2-3岁：创造力爆发期</h3>
<p>宝宝的想象力和创造力在这个阶段迅速发展。推荐磁力片、艺术绘画工具、过家家玩具、平衡车等。</p>
<p>蜜芽为您精选了乐高、费雪、面包超人等全球知名玩具品牌，所有产品均通过安全检测，让宝宝玩得开心、妈妈放心。</p>`,
    category: '育儿知识',
    tag: 'development',
    author: '蜜芽育儿专家团',
    date: '2025-11-12',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20wooden%20baby%20toys%20on%20soft%20beige%20playmat%20with%20gentle%20light%2C%20Montessori%20style%2C%20warm%20and%20inviting%20atmosphere&width=800&height=500&seq=article-3&orientation=landscape',
  },
  {
    slug: 'baby-clothing-guide',
    title: '宝宝衣服选购避坑指南：面料、尺码、安全性全解析',
    excerpt: '给宝宝买衣服看似简单，实则有很多讲究。从面料选择到尺码判断，从安全标准到洗涤方法，一文帮你避开所有选购误区。',
    content: `<p>给宝宝选购衣服是每位妈妈的必修课。面对琳琅满目的童装品牌和款式，如何挑选出安全、舒适又好看的宝宝衣服呢？以下是一份实用的选购指南。</p>
<h3>一、面料是第一要素</h3>
<p>宝宝皮肤娇嫩，衣服面料必须柔软亲肤、透气吸汗。纯棉是最推荐的面料选择，尤其是有机棉，在种植过程中不使用化学农药和化肥，对宝宝更加安全友好。</p>
<p><strong>A类标准：</strong>根据国家标准，婴幼儿服装应符合A类安全技术规范，甲醛含量、pH值等指标要求最为严格。购买时注意查看吊牌上的安全类别标注。</p>
<h3>二、尺码选择有讲究</h3>
<p>宝宝的尺码通常按月龄或身高标注，但不同品牌的尺码标准差异较大。建议按宝宝的实际身高选择，而非单纯看月龄。</p>
<p><strong>小贴士：</strong>宝宝长得快，不必一次性囤太多同尺码的衣服。每个尺码准备4-6套换洗即可，留出成长空间。</p>
<h3>三、安全性细节不容忽视</h3>
<p>避免选择带有过长绳索、小珠子、亮片等装饰物的衣服，这些可能造成缠绕或误吞风险。按扣和拉链应光滑牢固，标签最好设计在衣服外侧。</p>
<h3>四、洗涤与保养</h3>
<p>新买的宝宝衣服一定要先洗后穿。使用婴儿专用洗衣液，避免使用含有荧光剂和香精的产品。建议手洗或使用洗衣袋机洗，避免过度甩干导致变形。</p>
<p>蜜芽汇聚了Mini Rodini、Milkbarn等国际高端童装品牌，所有产品均符合婴幼儿A类安全标准，让宝宝穿出健康与时尚。</p>`,
    category: '育儿知识',
    tag: 'health',
    author: '蜜芽育儿专家团',
    date: '2025-10-28',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Soft%20organic%20cotton%20baby%20clothes%20folded%20neatly%20on%20light%20wood%20surface%2C%20warm%20sunlight%2C%20minimalist%20Scandinavian%20style&width=800&height=500&seq=article-4&orientation=landscape',
  },
  {
    slug: 'postpartum-recovery',
    title: '产后恢复全攻略：科学坐月子与身体修复的黄金法则',
    excerpt: '产后恢复是每位新妈妈最关注的话题。从科学坐月子到盆底肌修复，再到心理调适，本文为您提供一份全面科学的产后恢复方案。',
    content: `<p>宝宝的到来带来了喜悦，但生产过程对妈妈身体的消耗也是巨大的。科学的产后恢复不仅关系到身体健康，更影响着长期的生活质量。以下是一份全面的产后恢复指南。</p>
<h3>一、科学坐月子</h3>
<p>传统的"坐月子"有其合理性，但也存在一些需要科学看待的误区。现代产后护理强调营养均衡、适度活动和卫生清洁。</p>
<p><strong>营养补充：</strong>产后饮食应以高蛋白、高维生素、易消化为原则。多喝汤水有助于乳汁分泌，但不必过度油腻。适当补充铁、钙和DHA。</p>
<p><strong>个人卫生：</strong>产后可以洗澡洗头，但要注意保暖，洗完后立即擦干吹干。保持会阴部清洁干燥，预防感染。</p>
<h3>二、盆底肌修复</h3>
<p>无论是顺产还是剖腹产，盆底肌都会受到不同程度的损伤。盆底肌松弛可能导致漏尿、子宫脱垂等问题，需要及早进行修复训练。</p>
<p><strong>凯格尔运动</strong>是最基础有效的盆底肌训练方法，产后42天复查后即可在医生指导下开始练习。</p>
<h3>三、身体塑形</h3>
<p>产后身体塑形要有耐心，不可操之过急。一般建议产后6周开始轻度运动，3个月后逐步增加强度。收腹带可作为辅助工具，但不能替代核心肌群的锻炼。</p>
<h3>四、心理调适</h3>
<p>产后情绪波动是正常现象，但如果持续超过两周、影响日常生活，可能是产后抑郁的信号，需要及时寻求专业帮助。家人的理解和支持至关重要。</p>
<p>蜜芽关注每一位妈妈的全面健康，为您精选Mama&Kids等专业母婴护理品牌，陪伴您度过美好的育儿时光。</p>`,
    category: '妈妈护理',
    tag: 'mom-care',
    author: '蜜芽育儿专家团',
    date: '2025-10-15',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Serene%20bedroom%20with%20soft%20bedding%20and%20warm%20morning%20light%2C%20peaceful%20recovery%20atmosphere%2C%20cream%20and%20blush%20tones%2C%20motherhood%20wellness&width=800&height=500&seq=article-5&orientation=landscape',
  },
  {
    slug: 'baby-sleep-training',
    title: '宝宝睡眠训练法：从夜醒频繁到一觉到天亮的实用技巧',
    excerpt: '宝宝的睡眠问题困扰着无数妈妈。了解婴儿睡眠规律，掌握科学的哄睡方法，帮助宝宝建立健康的睡眠习惯。',
    content: `<p>"宝宝什么时候才能睡整觉？"这是几乎所有新手妈妈都会问的问题。婴儿的睡眠模式和成人有很大不同，了解这些差异是解决睡眠问题的第一步。</p>
<h3>一、婴儿睡眠规律</h3>
<p>新生儿的睡眠周期约为50-60分钟，远短于成人的90-120分钟。他们在浅睡眠阶段容易醒来，这是正常的生理现象。随着月龄增长，睡眠周期会逐渐延长。</p>
<p>0-3个月的宝宝每天需要14-17小时睡眠，4-11个月需要12-15小时，1-2岁需要11-14小时。</p>
<h3>二、建立睡前仪式</h3>
<p>固定的睡前仪式能够帮助宝宝建立"该睡觉了"的条件反射。推荐流程：温水澡 → 轻柔按摩 → 换上睡衣 → 喂奶 → 读绘本 → 关灯。</p>
<p>每天在同一时间开始睡前仪式，持之以恒，宝宝会逐渐适应这个节奏。</p>
<h3>三、自主入睡训练</h3>
<p>培养宝宝自主入睡的能力是睡眠训练的核心目标。当宝宝有睡意但仍清醒时放入婴儿床，让他学会自己入睡，而不是依赖抱着哄睡或含着奶嘴入睡。</p>
<p>常用的训练方法包括"抱起放下法"和"逐步撤离法"，选择适合自己宝宝的方法，保持耐心和一致性。</p>
<h3>四、营造睡眠环境</h3>
<p>黑暗、安静、温度适宜的环境有助于宝宝入睡。使用遮光窗帘，保持室温在20-22℃，湿度在50-60%。白噪音可以帮助掩盖环境中的突然声响。</p>
<p>每个宝宝都是独特的，有些方法可能需要尝试和调整。蜜芽陪伴每一位妈妈度过育儿的每一个挑战时刻。</p>`,
    category: '育儿知识',
    tag: 'health',
    author: '蜜芽育儿专家团',
    date: '2025-09-20',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20baby%20nursery%20with%20soft%20crib%20and%20gentle%20night%20light%2C%20calm%20atmosphere%2C%20cream%20walls%2C%20cozy%20bedding&width=800&height=500&seq=article-6&orientation=landscape',
  },
];

export const getArticlesByTag = (tag: string): Article[] => {
  if (!tag) return articles;
  return articles.filter((a) => a.tag === tag);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((a) => a.slug === slug);
};

export const getRecentArticles = (count: number = 3): Article[] => {
  return articles.slice(0, count);
};